import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import type { CarouselAPI } from '@elfsight/lib-carousel';
import type { LayoutAPI } from '@elfsight/widget-ui';
import { useData } from '../data';
import { Loader } from '../lib/components';
import { WidgetError } from '../main';
import { useTabs } from '../tabs';
import { useSocialFeedSettings } from '../utils';
import { variations } from './variations';

export function Layout() {
  const ref = useRef<LayoutAPI & CarouselAPI>(null);
  const { data, isLoading } = useData();
  const { layout } = useSocialFeedSettings();
  const { currentTab } = useTabs();

  const LayoutComponent = variations[layout];

  // Сброс layout при смене таба
  useEffect(() => {
    if (ref.current) {
      ref.current.resetLayout();
    }
  }, [currentTab.id]);

  if (isLoading && data.length === 0) {
    return <LayoutLoader />;
  }

  if (data.length === 0) {
    return (
      <WidgetError>
        No posts to display. The specified resources might be empty, or there
        could be set filters not satisfying any post.
      </WidgetError>
    );
  }

  return (
    <LayoutContainer>
      <LayoutComponent ref={ref} />
    </LayoutContainer>
  );
}

const LayoutContainer = styled.div`
  position: relative;
`;

const LayoutLoader = styled(Loader)`
  margin: 20px 0;
`;
